require('../../styles/blocks/identity/_post-office-identification.scss');
import React, { Fragment } from 'react';
import { FormattedText, formatText } from 'core/i18n';
const CourierIdentification = require('./courierIdentification').CourierIdentification;
const OfficeIdentification = require('./officeIdentification').OfficeIdentification;
import FeatureTogglingRender from 'components/featureToggling/featureTogglingRender';
import BoxTabs from '../newAccountSteps/profileSteps/profileStep3/BoxTabs/BoxTabs';
import { PHYSICALIDEN, COURIER } from 'constants/featureFlagging';
// @ HOCs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

class PostOffice extends React.Component {
    constructor(props) {
        super(props);
        const { flags } = props;
        this.state = {
            selectedItemIndex: flags.get(COURIER) ? 0 : 1,
        };
    }

    buildTabbedBox = () => {
        const { selectedItemIndex } = this.state;
        return (
            <div className="identification-tab-box">
                <BoxTabs callBack={this.onTabChange} styleTabs={'square-pills'} selectedTab={selectedItemIndex}>
                    {[formatText('identity-removeInPostOffice'), formatText('identity-sendHome')]}
                </BoxTabs>
            </div>
        );
    };

    onTabChange = index => {
        this.setState({ selectedItemIndex: index });
    };

    render() {
        const boxTabsItems = {
            0: <OfficeIdentification />,
            1: <CourierIdentification />,
        };
        const method = boxTabsItems[this.state.selectedItemIndex];
        return (
            <section className="post-office-content container">
                <div>
                    <FeatureTogglingRender productKeyFilter="every" notAllowedProductKey={[PHYSICALIDEN, COURIER]}>
                        <Fragment>
                            <header>
                                <p className="font-heading6">
                                    <FormattedText value="identification-headerChooseMethods" />
                                </p>
                            </header>
                            <div className="post-office-methods">{this.buildTabbedBox()}</div>
                        </Fragment>
                    </FeatureTogglingRender>
                    <div>
                        <div className="post-office-methods__method'">{method}</div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withFeatureToggling(PostOffice);
